import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AlertService } from '../../../services/alert.service';
import { NewsletterService } from '../../../services/newsletter.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-newsletter-signup-dialog',
  templateUrl: './newsletter-signup-dialog.component.html',
  styleUrl: './newsletter-signup-dialog.component.scss',
  standalone: false,
})
export class NewsletterSignupDialogComponent {
  public isLoading = false;

  constructor(
    private newsletterService: NewsletterService,
    private alertService: AlertService,
    public userService: UserService,
    private dialogRef: DynamicDialogRef
  ) {}

  public subscribe(): void {
    this.isLoading = true;
    this.newsletterService.subscribeLoggedIn().subscribe({
      next: () => {
        const currentUser = this.userService.currentUser$.value;
        if (currentUser) {
          this.userService.currentUser$.next({
            ...currentUser,
            newsletterSubscribed: true,
          });
          this.userService.setUser({
            ...currentUser,
            newsletterSubscribed: true,
          });
        }
        this.alertService.showSuccessAlert(
          'Du hast dich erfolgreich für den Newsletter angemeldet.'
        );
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: () => {
        this.alertService.showErrorAlert(
          'Die Newsletter-Anmeldung konnte leider nicht abgeschlossen werden. Bitte versuche es später erneut.'
        );
        this.isLoading = false;
      },
    });
  }

  public dismiss(): void {
    const userId = this.userService.currentUser$.value?.id;
    if (userId) {
      localStorage.setItem(`inwi_newsletter_popup_dismissed`, 'true');
    }
    this.dialogRef.close(false);
  }
}
